// Copyright (c) 2016 HVIKT AS
(function() {
    'use strict';

    angular
        .module('app')
        .filter('true_false', trueFalse);

    trueFalse.$inject = [];

    function trueFalse() {
        return function (text) {
            if (text) {
                return 'Ja';
            }
            return 'Nei';
        };
    }
})();